import { useMutation } from "@apollo/client";
import { REMOVE_CUSTOMER_TASK } from "../customer-task.queries";
import {
  RemoveCustomerTaskMutation,
  RemoveCustomerTaskMutationVariables,
} from "../../../__generated__/RemoveCustomerTaskMutation";

export const useRemoveCustomerTask = () => {
  return useMutation<RemoveCustomerTaskMutation, RemoveCustomerTaskMutationVariables>(
    REMOVE_CUSTOMER_TASK,
    {
      refetchQueries: ["CustomerTasksQuery"],
    }
  );
};
